import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  body {
    background: ${(props) => props.theme.body};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }
`;

export const MyThemes = (theme) => {
  switch (theme) {
    case 'dark':
      return darkTheme;
    case 'light':
      return lightTheme;
    default:
      return lightTheme;
  }
};

const size = {
  mobile: '320px',
  tablet: '768px',
  desktop: '1024px',
  widest: '1440px',
};

export const device = {
  mobile: `(min-width: ${size.mobile})`,
  tablet: `(min-width: ${size.tablet})`,
  desktop: `(min-width: ${size.desktop})`,
  widest: `(min-width: ${size.widest})`,
};

export const convertWidth = (context, width) => {
  const base = 100 / context;
  return base * width * 1 + `%`;
};

export const theme = {
  base: 16,
  primaryFull: '#F8A51B',
  primary75: '#fabb54',
  primary50: 'rgba(248, 165, 27, 0.5)',
  primary30: 'rgba(248, 165, 27, 0.3)',
  primary25: 'rgba(248, 165, 27, 0.25)',
  primary20: 'rgba(248, 165, 27, 0.2)',
  primary15: 'rgba(248, 165, 27, 0.15)',
  primary10: 'rgba(248, 165, 27, 0.1)',
  primary5: 'rgba(248, 165, 27, 0.05)',
  primaryAAA: '#7B370A',
  primaryAA: '#A4470A',
  black: '#000000',
  blackFull: '#10100F',
  black90: '#282827',
  black85: 'rgba(16, 16, 15, 0.85)',
  black80: 'rgba(16, 16, 15, 0.8)',
  black75: '#4C4C4B',
  black65: 'rgba(16, 16, 15, 0.65)',
  black50: 'rgba(16, 16, 15, 0.5)',
  black40: 'rgba(16, 16, 15, 0.4)',
  black35: 'rgba(16, 16, 15, 0.35)',
  black25: 'rgba(16, 16, 15, 0.25)',
  black15: 'rgba(16, 16, 15, 0.15)',
  black10: 'rgba(16, 16, 15, 0.1)',
  black5: 'rgba(16, 16, 15, 0.05)',
  black1: 'rgba(16, 16, 15, 0.01)',
  black0: 'rgba(16, 16, 15, 0)',
  greyFull: '#6A707C',
  grey75: '#8F949D',
  grey50: '#B4B7BD',
  grey25: 'rgba(106, 112, 124, 0.25)',
  grey10: 'rgba(106, 112, 124, 0.1)',
  grey5: 'rgba(106, 112, 124, 0.05)',
  darkGrey25: 'rgba(199, 199, 198, 0.25)',
  white: '#FFFFFF',
  whiteFull: '#FBFBFB',
  white90: '#E8E8E8',
  white85: 'rgba(251, 251, 251, 0.85)',
  white75: 'rgba(251, 251, 251, 0.75)',
  white70: 'rgba(251, 251, 251, 0.7)',
  white65: 'rgba(251, 251, 251, 0.65)',
  white50: 'rgba(251, 251, 251, 0.5)',
  white40: 'rgba(251, 251, 251, 0.4)',
  white25: 'rgba(251, 251, 251, 0.25)',
  white20: 'rgba(251, 251, 251, 0.2)',
  white15: 'rgba(251, 251, 251, 0.15)',
  white10: 'rgba(251, 251, 251, 0.1)',
  white5: 'rgba(251, 251, 251, 0.05)',
  white1: 'rgba(251, 251, 251, 0.01)',
  white0: 'rgba(251, 251, 251, 0)',
  statusRed: '#F04A4A',
  statusAmber: '#F2C551',
  statusGreen: '#3CD771',
  statusLightFocus: '#0E92A4',
  statusDarkFocus: '#1BDEF8',
  btnBgBlack: 'rgba(40, 40, 39, 1)',
  btnBgWhite: 'rgba(232, 232, 232, 1)',
  unavailableDark: 'rgba(239, 239, 240, 0.6)',
  unavailableLight: 'rgba(16, 16, 15, 0.7)',
  fontBold: `
    font-family: "Gotham Narrow SSm 7r", "Gotham Narrow SSm A", "Gotham Narrow SSm B", "HelveticaNeue-Bold", "Helvetica Neue Bold","Helvetica Neue", Helvetica, Verdana, sans-serif; font-weight: normal;`,
  fontBook: `    
    font-family: "Gotham Narrow SSm 4r", "Gotham Narrow SSm A", "Gotham Narrow SSm B", "HelveticaNeue-Regular", "Helvetica Neue Regular", "Helvetica Neue", Helvetica, Verdana, sans-serif; font-weight: normal;`,
  font: {
    h1: `
      font-size: 6em;
      font-weight: bold;
      letter-spacing: -0.035em;
      line-height: 1.1em;
    `,
    h2: `
      font-size: 3.75em;
      font-weight: bold;
      letter-spacing: -0.035em;
      line-height: 1.1em;
    `,
    h3: `
      font-size: 3em;
      font-weight: bold;
      letter-spacing: -0.035em;
      line-height: 1.1em;
    `,
    h4: `
      font-size: 2.125em;
      font-weight: bold;
      letter-spacing: -0.035em;
      line-height: 1.1em;
    `,
    h5: `
      font-size: 1.5em;
      font-weight: bold;
      letter-spacing: -0.035em;
      line-height: 1.1em;
    `,
    h6: `
      font-size: 1.25em;
      font-weight: bold;
      letter-spacing: -0.035em;
      line-height: 1.1em;
    `,
    subtitle: {
      book: `
        font-size: 1em;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 1.4em;
      `,
      bold: `
        font-size: 1em;
        font-weight: bold;
        letter-spacing: 0px;
        line-height: 1.4em;
      `,
    },
    subtitle2: {
      book: `
        font-size: 0.875em;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 1.4em;
      `,
      bold: `
        font-size: 0.875em;
        font-weight: bold;
        letter-spacing: 0px;
        line-height: 1.4em;
      `,
    },
    body: {
      book: `
        font-size: 1em;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 1.4em;
      `,
      bold: `
        font-size: 1em;
        font-weight: bold;
        letter-spacing: 0px;
        line-height: 1.4em;
      `,
    },
    body2: {
      book: `
        font-size: 0.875em;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 1.4em;
      `,
      bold: `
        font-size: 0.875em;
        font-weight: bold;
        letter-spacing: 0px;
        line-height: 1.4em;
      `,
    },
    caption: {
      small: `
        font-size: 0.75em;
        font-weight: 500;
        letter-spacing: 0.1px;
        line-height: 1.4em;
      `,
      medium: `
        font-size: 0.8125em;
        font-weight: 400;
        letter-spacing: 0.1px;
        line-height: 1.4em;
      `,
    },
    overline: `
      font-size: 0.6875em;
      font-weight: bold;
      letter-spacing: 0.3px;
      line-height: 1.4em;
      text-transform: uppercase;
    `,
    micro: `
      font-size: 0.625em;
      font-weight: 600;
      letter-spacing: 0.4px;
      line-height: 1.4em;
      text-transform: uppercase;
    `,
  },
  clearFix: `
    &:after {
      content: '';
      display: table;
      clear: both;
    }
  `,
};

export const darkTheme = {
  name: 'dark',
  body: `${theme.blackFull}`,
  color: {
    primaryFull: `${theme.primaryFull}`,
    primary75: `${theme.primary75}`,
    primary50: `${theme.primary50}`,
    primary30: `${theme.primary30}`,
    primary25: `${theme.primary25}`,
    primary20: `${theme.primary20}`,
    primary15: `${theme.primary15}`,
    primary10: `${theme.primary10}`,
    primary5: `${theme.primary5}`,
    primaryAAA: `${theme.primaryAAA}`,
    primaryAA: `${theme.primaryAA}`,
    black: `${theme.black}`,
    blackFull: `${theme.blackFull}`,
    black90: `${theme.black90}`,
    black85: `${theme.black85}`,
    black80: `${theme.black80}`,
    black75: `${theme.black75}`,
    black65: `${theme.black65}`,
    black50: `${theme.black50}`,
    black40: `${theme.black40}`,
    black35: `${theme.black35}`,
    black25: `${theme.black25}`,
    black15: `${theme.black15}`,
    black10: `${theme.black10}`,
    black5: `${theme.black5}`,
    black1: `${theme.black1}`,
    black0: `${theme.black0}`,
    greyFull: `${theme.greyFull}`,
    grey75: `${theme.grey75}`,
    grey50: `${theme.grey50}`,
    grey25: `${theme.grey25}`,
    grey10: `${theme.grey10}`,
    grey5: `${theme.grey5}`,
    darkGrey25: `${theme.darkGrey25}`,
    white: `${theme.white}`,
    whiteFull: `${theme.whiteFull}`,
    white90: `${theme.white90}`,
    white85: `${theme.white85}`,
    white75: `${theme.white75}`,
    white70: `${theme.white70}`,
    white65: `${theme.white65}`,
    white50: `${theme.white50}`,
    white40: `${theme.white40}`,
    white25: `${theme.white25}`,
    white20: `${theme.white20}`,
    white15: `${theme.white15}`,
    white10: `${theme.white10}`,
    white5: `${theme.white5}`,
    white1: `${theme.white1}`,
    white0: `${theme.white0}`,
    statusRed: `${theme.statusRed}`,
    statusAmber: `${theme.statusAmber}`,
    statusGreen: `${theme.statusGreen}`,
    statusLightFocus: `${theme.statusLightFocus}`,
    statusDarkFocus: `${theme.statusDarkFocus}`,
    btnBgBlack: `${theme.btnBgBlack}`,
    btnBgWhite: `${theme.btnBgWhite}`,
    unavailableDark: `${theme.unavailableDark}`,
    unavailableLight: `${theme.unavailableLight}`,
  },
  fontBold: `${theme.fontBold}`,
  fontBook: `${theme.fontBook}`,
  font: {
    h1: `${theme.font.h1}`,
    h2: `${theme.font.h2}`,
    h3: `${theme.font.h3}`,
    h4: `${theme.font.h4}`,
    h5: `${theme.font.h5}`,
    h6: `${theme.font.h6}`,
    subtitle: {
      book: `${theme.font.subtitle.book}`,
      bold: `${theme.font.subtitle.bold}`,
    },
    subtitle2: {
      book: `${theme.font.subtitle2.book}`,
      bold: `${theme.font.subtitle2.bold}`,
    },
    body: {
      book: `${theme.font.body.book}`,
      bold: `${theme.font.body.bold}`,
    },
    body2: {
      book: `${theme.font.body2.book}`,
      bold: `${theme.font.body2.bold}`,
    },
    caption: {
      small: `${theme.font.caption.small}`,
      medium: `${theme.font.caption.medium}`,
    },
    overline: `${theme.font.overline}`,
    micro: `${theme.font.micro}`,
  },
  focusRing: `0px 0px 0px 2px ${theme.statusDarkFocus}`,
  clearFix: `${theme.clearFix}`,
};

export const lightTheme = {
  name: 'light',
  body: `${theme.whiteFull}`,
  color: {
    primaryFull: `${theme.primaryFull}`,
    primary75: `${theme.primary75}`,
    primary50: `${theme.primary50}`,
    primary30: `${theme.primary30}`,
    primary25: `${theme.primary25}`,
    primary20: `${theme.primary20}`,
    primary15: `${theme.primary15}`,
    primary10: `${theme.primary10}`,
    primary5: `${theme.primary5}`,
    primaryAAA: `${theme.primaryAAA}`,
    primaryAA: `${theme.primaryAA}`,
    black: `${theme.black}`,
    blackFull: `${theme.blackFull}`,
    black90: `${theme.black90}`,
    black85: `${theme.black85}`,
    black80: `${theme.black80}`,
    black75: `${theme.black75}`,
    black65: `${theme.black65}`,
    black50: `${theme.black50}`,
    black40: `${theme.black40}`,
    black35: `${theme.black35}`,
    black25: `${theme.black25}`,
    black15: `${theme.black15}`,
    black10: `${theme.black10}`,
    black5: `${theme.black5}`,
    black1: `${theme.black1}`,
    black0: `${theme.black0}`,
    greyFull: `${theme.greyFull}`,
    grey75: `${theme.grey75}`,
    grey50: `${theme.grey50}`,
    grey25: `${theme.grey25}`,
    grey10: `${theme.grey10}`,
    grey5: `${theme.grey5}`,
    darkGrey25: `${theme.darkGrey25}`,
    white: `${theme.white}`,
    whiteFull: `${theme.whiteFull}`,
    white90: `${theme.white90}`,
    white85: `${theme.white85}`,
    white75: `${theme.white75}`,
    white70: `${theme.white70}`,
    white65: `${theme.white65}`,
    white50: `${theme.white50}`,
    white40: `${theme.white40}`,
    white25: `${theme.white25}`,
    white20: `${theme.white20}`,
    white15: `${theme.white15}`,
    white10: `${theme.white10}`,
    white5: `${theme.white5}`,
    white1: `${theme.white1}`,
    white0: `${theme.white0}`,
    statusRed: `${theme.statusRed}`,
    statusAmber: `${theme.statusAmber}`,
    statusGreen: `${theme.statusGreen}`,
    statusLightFocus: `${theme.statusLightFocus}`,
    statusDarkFocus: `${theme.statusDarkFocus}`,
    btnBgBlack: `${theme.btnBgBlack}`,
    btnBgWhite: `${theme.btnBgWhite}`,
    unavailableDark: `${theme.unavailableDark}`,
    unavailableLight: `${theme.unavailableLight}`,
  },
  fontBold: `${theme.fontBold}`,
  fontBook: `${theme.fontBook}`,
  font: {
    h1: `${theme.font.h1}`,
    h2: `${theme.font.h2}`,
    h3: `${theme.font.h3}`,
    h4: `${theme.font.h4}`,
    h5: `${theme.font.h5}`,
    h6: `${theme.font.h6}`,
    subtitle: {
      book: `${theme.font.subtitle.book}`,
      bold: `${theme.font.subtitle.bold}`,
    },
    subtitle2: {
      book: `${theme.font.subtitle2.book}`,
      bold: `${theme.font.subtitle2.bold}`,
    },
    body: {
      book: `${theme.font.body.book}`,
      bold: `${theme.font.body.bold}`,
    },
    body2: {
      book: `${theme.font.body2.book}`,
      bold: `${theme.font.body2.bold}`,
    },
    caption: {
      small: `${theme.font.caption.small}`,
      medium: `${theme.font.caption.medium}`,
    },
    overline: `${theme.font.overline}`,
    micro: `${theme.font.micro}`,
  },
  focusRing: `0px 0px 0px 2px ${theme.statusLightFocus}`,
  clearFix: `${theme.clearFix}`,
};
